import queryString from 'query-string';
import { countries } from '../config';
import * as experiments from '../flags/experiments';
import * as features from '../flags/features';
import { CONFIG } from './types';

const DEFAULT_FLAGS = {
  supportedCountries: countries.map((country) => country.isoCode),
  experimentsArray: Object.values(experiments),
  featuresArray: Object.values(features),
};

export const featureParams = ({ featuresArray, experimentsArray, supportedCountries }) =>
  queryString.stringify({
    features: featuresArray.length ? featuresArray.join(',') : '',
    ab_tests: experimentsArray.length ? experimentsArray.join(',') : '',
    supported_countries: supportedCountries.join(','),
  });

export const requestConfig = ({
  featuresArray,
  experimentsArray,
  supportedCountries,
} = DEFAULT_FLAGS) => ({
  type: CONFIG,
  endpoint: `/orderapp/v1/config?${featureParams({
    featuresArray,
    experimentsArray,
    supportedCountries,
  })}`,
  options: {
    method: 'GET',
  },
});
